<template lang="pug">
bottom-modal(:id="modalId" width="w-xtra-large")
    span(slot="header-text") Shelf Labels

    div(slot="body")
        div(v-if="mode === 1")
            shelf-labels-products(ref="shelfLabelProducts")

        div(v-if="mode === 2")
            shelf-labels-retailers

    button.btn.btn-fw.primary(
        v-if="mode === 1"
        slot="footer"
        @click="process"
        :disabled="(!data.length && !addAllMatching) || onLoading('generate-barcode')"
    )
        v-loading(loader="generate-barcode") {{ toggle ? 'Print' : 'Next' }}

    button.btn.btn-fw.primary(
        v-if="mode === 2"
        slot="footer"
        @click="processEmail"
        :disabled="(!data.length && !addAllMatching) || onLoading('generate-barcode') || !retailers.length"
    )
        v-loading(loader="generate-barcode") Send Email
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import shelfLabelsProducts from './shelf-labels-products.vue';
import shelfLabelsRetailers from './shelf-labels-retailers.vue';
import formattedCurrency from '../../../../mixins/formatted-currency';

export default {
    components: { shelfLabelsProducts, shelfLabelsRetailers },

    mixins: [formattedCurrency],

    data() {
        return {
            modalId: 'shelfLabel',
            filters: {
                category: null,
                tags: [],
                search: null,
                shelfSpacePlan: [],
            },
        };
    },

    computed: {
        ...mapGetters('override_pricebook', ['pricebook']),

        ...mapGetters('shelfLabel', [
            'data',
            'toggle',
            'mode',
            'addAllMatching',
            'retailers',
        ]),
    },

    created() {
        this.$on('show', () => {
            this.showModal();
            this.reset();
        });
    },

    methods: {
        ...mapActions('shelfLabel', ['print', 'sendEmail']),

        ...mapMutations('shelfLabel', ['setMode', 'reset']),

        showModal() {
            $(`#${this.modalId}`).modal('show');
        },

        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        process() {
            if (this.toggle) {
                this.printLabels();
            } else {
                this.changeModeEmail();
            }
        },

        async printLabels() {
            try {
                await this.print({
                    id: this.pricebook.id,
                    model: 'override_pricebook_products',
                    column: 'override_pricebook_id',
                    filters: this.filters,
                    currency: this.getCurrency(),
                });

                this.showToastrSuccess();
            } catch (e) {
                this.showApiError(e);
            }
        },

        changeModeEmail() {
            this.setMode(2);
        },

        async processEmail() {
            try {
                await this.sendEmail({
                    id: this.pricebook.id,
                    model: 'override_pricebook_products',
                    column: 'override_pricebook_id',
                    filters: this.filters,
                    type: 'retailers',
                });

                this.showToastrSuccess();
                this.hideModal();
            } catch (e) {
                this.showApiError(e);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/shelf-labels/shelf-labels-index.vue